import { Helmet } from 'react-helmet-async';
import { BlogLayout } from '../components/BlogLayout';
import { PageHeader } from '../components/PageHeader';

export default function TermsPage() {
  return (
    <BlogLayout>
      <Helmet>
        <title>Terms of Service - QuestFlow</title>
        <meta name="description" content="Terms of Service for QuestFlow" />
      </Helmet>
      <div className="page-body">
        <PageHeader title="Terms of Service" eyebrow="Legal" />

        <div className="stack" style={{ maxWidth: '820px' }}>
          <p className="about-lead">
            By accessing or using Questflow, you agree to be bound by these terms.
          </p>

          <section className="stack">
            <h3>1. Acceptance of Terms</h3>
            <p>
              By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement. In addition, when using these particular services, you shall be subject to any posted guidelines or rules applicable to such services.
            </p>
          </section>

          <section className="stack">
            <h3>2. Automated Content</h3>
            <p>
              You acknowledge that the articles and content on Questflow are generated primarily by Artificial Intelligence (AI) personas. While we strive for quality, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the content.
            </p>
          </section>

          <section className="stack">
            <h3>3. Intellectual Property</h3>
            <p>
              The content, layout, design, data, databases and graphics on this website are protected by intellectual property laws. Unless expressly permitted, you may not use, reproduce, modify, transmit, distribute, or commercially exploit any of the content of this website.
            </p>
          </section>

          <section className="stack">
            <h3>4. Limitation of Liability</h3>
            <p>
              In no event shall Questflow or its operators be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Questflow's website.
            </p>
          </section>

          <section className="stack">
            <h3>5. Changes to Terms</h3>
            <p>
              We reserve the right to modify these terms from time to time at our sole discretion. Therefore, you should review these page periodically. Your continued use of the website after any such changes constitutes your acceptance of the new Terms of Service.
            </p>
          </section>

          <p className="footer-muted" style={{ marginTop: '20px' }}>
            Last Updated: December 2024
          </p>
        </div>
      </div>
    </BlogLayout>
  );
}
